const switcherButtons = document.querySelector('.shopify-section--dual-brand-hero .media-switch-buttons');
switcherButtons && document.documentElement.style.setProperty('--switch-buttons-height', `${Math.round(switcherButtons.clientHeight)}px`);
document.addEventListener('DOMContentLoaded', function() {
  const videoContainer = document.querySelector('.updated-video-container');
  if (!videoContainer) return;
  
  const mediaPlayers = videoContainer.querySelectorAll('.media-player');
  const switchButtons = videoContainer.querySelectorAll('.media-switch-btn');
  const mediaOverlays = videoContainer.querySelectorAll('.media-overlay');
  const shadowOverlays = videoContainer.querySelectorAll('.shadow-overlay');
  const transitionGif = videoContainer.querySelector('.transition-gif');

  function getBrandParam(){
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const brandParam = params?.get('brand');
    return { queryString, params, brandParam };
  }
  const { queryString, params, brandParam } = getBrandParam();
  let currentMedia = 1;
  if(brandParam){
    const match = Array.from(switchButtons).find((button) => button.dataset.brandName === brandParam);
    if(match){
      currentMedia = match.dataset.targetMedia;
    }
  }
  let isTransitioning = false;
  
  function showMedia(mediaId) {
    if (isTransitioning) return;
    
    // Hide all media
    mediaPlayers.forEach(player => {
      player.classList.add('hidden');
      player.style.display = 'none';
    });
    
    // Show target media
    const targetMedia = videoContainer.querySelector(`[data-media-id="${mediaId}"]`);
    //console.log('targetMedia: ', targetMedia, mediaId)
    if (targetMedia) {
      targetMedia.classList.remove('hidden');
      targetMedia.style.display = '';
      currentMedia = mediaId;
    }
    
    // Hide all overlays
    mediaOverlays.forEach(overlay => {
      overlay.classList.add('hidden');
    });
    
    // Hide all shadow overlays
    shadowOverlays.forEach(overlay => {
      overlay.classList.add('hidden');
    });
    
    // Show target overlay
    const targetOverlay = videoContainer.querySelector(`[data-overlay-id="${mediaId}"]`);
    if (targetOverlay) {
      targetOverlay.classList.remove('hidden');
    }
    
    // Show target shadow overlay
    const targetShadowOverlay = videoContainer.querySelector(`[data-shadow-id="${mediaId}"]`);
    if (targetShadowOverlay) {
      targetShadowOverlay.classList.remove('hidden');
    }
    
    // Update button states
    switchButtons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.targetMedia == mediaId);
      if(btn.dataset.targetMedia == mediaId){
        setBrandStyles(btn.dataset.brandSchemeId, btn.dataset.brandName)
      }
    });
  }
  
  function setBrandStyles(brandSchemeId, brandName) {
    if(brandSchemeId && brandName){
      const schemedElements = document.querySelectorAll('.color-scheme');
      Array.from(schemedElements).forEach((element) => {
        // Filter classes that start with 'color-scheme--'
        const elementColorSchemeClasses = Array.from(element.classList).filter((className) => {
          return /^color-scheme--/.test(className);
        });
        
        elementColorSchemeClasses.forEach((oldClass) => {
          element.classList.replace(oldClass, `color-scheme--${brandSchemeId}`);
        })
      });
      const { queryString, params, brandParam } = getBrandParam();
      if(!brandParam || brandName !== brandParam){
        params.set('brand', brandName);
        window.history.replaceState({}, "", "?" + params.toString());
      }
    }
  }
  
  function playTransitionGif(callback) {
    if (!transitionGif || isTransitioning) {
      if (callback) callback();
      return;
    }
    
    isTransitioning = true;      
    transitionGif.classList.remove('hidden');
    const transitionDuration = 500;
    
    setTimeout(() => {
      transitionGif.classList.add('hidden');
      isTransitioning = false;
      if (callback) callback();
    }, transitionDuration);
  }
  
  // Add click handlers to switch buttons
  switchButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const targetMedia = this.dataset.targetMedia;
      if (targetMedia != currentMedia) {
        playTransitionGif(() => {
          showMedia(targetMedia);
        });
      }
    });
  });
  
  // Initialize with first media active
  showMedia(currentMedia);
});